import {constants} from "../../../constants";
export default class SuspendGame {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.game.suspendGame();
    }

    PLAYTECH_close_handler() {
        this.gb.emitters.emit.web.closeGame({type:'w2gCloseGameRequest'})
        this.gb.emitters.emit.game.suspendGame()
    }

    POKERSTARS_handler() {
        const dataForXc = {'msgId':'rg2xcGameReadyForUnload'};

        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify(dataForXc), "*");
        }

        let frame = document.getElementById("gameWindow");
        frame.parentNode.removeChild(frame);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            case constants.PLAYTECH:
                event["ucip.closegame.w2gCloseGameRequest"] = this.PLAYTECH_close_handler
                break;
            case constants.POKERSTARS:
                event["xc2rgCloseGame"] = this.POKERSTARS_handler
                break;
            default:
                event["doGameSuspend"] = this._default
        }

        return event;
    }
}
